import React, { useEffect, useState } from "react";
import Axios from "../../axios/axios";

export default function ReturnReport() {
  const today = new Date().toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);

  const [returnType, setReturnType] = useState("returned");

  const [returnedData, setReturnedData] = useState([]);
  const [returnedCount, setReturnedCount] = useState(0);

  const [todayReturnData, setTodayReturnData] = useState([]);
  const [todayReturnCount, setTodayReturnCount] = useState(0);
  const [returnedAmount, setReturnedAmount] = useState(0);
  const [todayReturnAmount, setTodayReturnAmount] = useState(0);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");

  const tableData = returnType === "returned" ? returnedData : todayReturnData;

  const totalCount =
    returnType === "returned" ? returnedCount : todayReturnCount;

  const getReturnedReport = async () => {
    try {
      const res = await Axios.get(
        `/api/order/returnReport?from=${fromDate}&to=${toDate}&user=${selectedUser}`,
      );

      const reportData = res.data.data;

      setReturnedData(reportData);
      setReturnedCount(res.data.count);
      const total = reportData.reduce(
        (sum, item) => sum + (item.amount || 0),
        0,
      );
      setReturnedAmount(total);

      const uniqueUsers = [];

      reportData.forEach((item) => {
        const exists = uniqueUsers.find((u) => u.name === item.customer?.name);

        if (!exists) {
          uniqueUsers.push({
            _id: item.customer?._id,
            name: item.customer?.name,
          });
        }
      });

      if (!selectedUser) {
        setUsers(uniqueUsers);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getToBeReturnedTodayReport = async () => {
    try {
      const res = await Axios.get(
        `/api/order/toBeReturnedTodayReport?date=${fromDate}&user=${selectedUser}`,
      );
      const reportData = res.data.data;
      console.log("reportdata", reportData);

      setTodayReturnData(reportData);
      setTodayReturnCount(res.data.count);
      const total = reportData.reduce(
        (sum, item) => sum + (item.amount || 0),
        0,
      );
      setTodayReturnAmount(total);

      const uniqueUsers = [];

      reportData.forEach((item) => {
        const exists = uniqueUsers.find((u) => u.name === item.customer?.name);

        if (!exists) {
          uniqueUsers.push({
            _id: item.customer?._id,
            name: item.customer?.name,
          });
        }
      });

      if (!selectedUser) {
        setUsers(uniqueUsers);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (returnType === "returned") {
      getReturnedReport();
    } else {
      getToBeReturnedTodayReport();
    }
  }, [fromDate, toDate, selectedUser, returnType]);

  const totalAmount =
    returnType === "returned" ? returnedAmount : todayReturnAmount;

  const changeDate = (days) => {
    const current = new Date(fromDate);
    current.setDate(current.getDate() + days);

    const newDate = current.toISOString().split("T")[0];

    setFromDate(newDate);
    setToDate(newDate);
  };
  const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
};
  return (
    <div>
      <div className="mb-3">
        <button
          className={`btn mr-2 mb-2 ${
            returnType === "returned" ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => {
            setReturnType("returned");
            setSelectedUser("");
          }}
        >
          Returned
        </button>

        <button
          className={`btn mb-2 ${
            returnType === "today" ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => {
            setReturnType("today");
            setSelectedUser("");
          }}
        >
          To Be Returned 
        </button>
      </div>
      <div className="card mb-3">
        <div className="card-body d-flex align-items-end gap-3 flex-wrap">
          <div className="mr-3">
            <label>From</label>
            <input
              type="date"
              className="form-control"
              // disabled={returnType === "today"}
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div className="mr-3">
            <label>To</label>
            <input
              type="date"
              className="form-control"
              // disabled={returnType === "today"}
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          <button
            className="btn btn-outline-primary"
            onClick={() => {
              setFromDate(today);
              setToDate(today);
            }}
            disabled={fromDate === today}
          >
            📅 Today
          </button>

          <button
            className="btn btn-outline-secondary"
            onClick={() => changeDate(1)}
          >
            Next ➡️
          </button>

          <button
            className="btn btn-primary"
            onClick={() => {
              if (returnType === "returned") {
                getReturnedReport();
              } else {
                getToBeReturnedTodayReport();
              }
            }}
          >
            Filter
          </button>
        </div>
      </div>

      <div className="mr-3 mb-3">
        <label>Customer</label>

        <select
          className="form-control"
          value={selectedUser}
          onChange={(e) => setSelectedUser(e.target.value)}
        >
          <option value="">All Customers</option>

          {users.map((u) => (
            <option key={u._id} value={u._id}>
              {u.name}
            </option>
          ))}
        </select>
      </div>

      <div className="row mb-4">
        <div className="col-md-3">
          <div className="card text-white bg-warning mb-2">
            <div className="card-body">
              <h6>Total Items To Return</h6>
              <h3>{totalCount}</h3>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card text-white bg-success">
            <div className="card-body">
              <h6>Total Amount</h6>
              <h3>₹ {totalAmount}</h3>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Return Details</h4>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Order ID</th>
                  <th>Customer</th>
                  <th>Product</th>
                  <th>Phone</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Return Date</th>
                  <th>Amount</th>
                </tr>
              </thead>

              <tbody>
                {tableData.length > 0 ? (
                  tableData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>ADC_{item.orderId}</td>
                      <td>{item.customer?.name}</td>
                      <td>{item.product}</td>
                      <td>{item.customer?.phone || "-"}</td>
                      <td>
                        {item.startDate
                          ? formatDate(item.startDate)
                          : "-"}
                      </td>

                      <td>
                        {item.endDate
                          ? formatDate(item.endDate)
                          : "-"}
                      </td>
                      <td>
                        {item.returnedAt
                          ? formatDate(item.returnedAt)
                          : "-"}
                      </td>
                      <td>₹ {item.amount}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No return records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
